import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useDrawer } from 'src/hooks/useDrawer';
import { useRoute } from 'src/router/hooks/useRoute';
import bg from './assets/bg.webp';
import { EVENT_SHOP_NAME } from 'src/config/event/eventConfig';
import { isShowEvent } from 'src/config/event/utils';

export const SidebarShopBanner = () => {
  const navigate = useNavigate();
  const { closeDrawer } = useDrawer();
  const { t } = useTranslation();
  const { ROUTE } = useRoute();

  const handlerBannerClick = () => {
    closeDrawer();
    navigate(ROUTE.EVENT_SHOP.get());
  };

  if (!isShowEvent('EVENT_SHOP')) return null;

  return (
    <div
      className="w-full h-10 !bg-no-repeat !bg-cover self-start rounded-lg overflow-hidden relative flex items-center cursor-pointer"
      style={{ background: `url(${bg})` }}
      onClick={handlerBannerClick}>
      <p className="text-ch_button_title font-semibold text-sm pl-3 py-2">
        {t(`${EVENT_SHOP_NAME}.shopButtonTitle`)}
      </p>
    </div>
  );
};
